import React, { useEffect, useState } from "react";
import LegalPage, { DomainDetails } from "./LegalPage";
import { fetchDomainDetails } from "./domainDetailsApi";
import { termsAndConditionsSections } from "./legalPagesData";
const TermsAndConditions: React.FC = () => {
  const [domainDetails, setDomainDetails] = useState<DomainDetails>({});

  useEffect(() => {
    fetchDomainDetails()
      .then(setDomainDetails)
      .catch((error) => {
        console.error("Domain API Error:", error);
        setDomainDetails({});
      });
  }, []);

  return (
    <LegalPage
      title="Terms & Conditions"
      description=""
      effectiveDate="19 February 2026"
      sections={termsAndConditionsSections}
      domainDetails={domainDetails}
    />
  );
};

export default TermsAndConditions;
